import { render, staticRenderFns } from "./VisitGram.vue?vue&type=template&id=c06bd8c2"
import script from "./VisitGram.vue?vue&type=script&lang=ts"
export * from "./VisitGram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports